<div class="pagination-container">
  <div class="drop-down">
    <kion-drop-down
      [options]="perPage"
      [showDropDownOnClick]="true"
      [showSelectedOption]="true"
      (selected)="dropDownOptionSelected($event)"
    ></kion-drop-down>
  </div>
  <div class="paginator" *ngIf="totalPages > 1">
    <div class="button arrow left {{ !canGotoPrevious ? 'disabled' : '' }}" (click)="gotoPrevious()">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M11.934 16.01L5.714 9.791 11.934 3.571 12.944 4.581 7.734 9.791 12.944 15z"/>
      </svg>
    </div>
    <ng-container *ngIf="showFirstPage">
      <div *ngIf="!isLink else asLink" class="button page {{currentPage === 1 ? 'active' : ''}}" (click)="goto(1)">
        1
      </div>
      <ng-template #asLink>
        <a [customRouterLink]="getGoToLink(1)" [params]="getQueryParams(1)" class="button page {{currentPage === 1 ? 'active' : ''}}">
          1
        </a>
      </ng-template>
    </ng-container>
    <ng-container *ngIf="showFirstPageEllipsis"><div class="ellipsis">...</div></ng-container>
    <ng-container *ngFor="let page of pages">
      <div *ngIf="!isLink else asLink" class="button page {{currentPage === page ? 'active' : ''}}" (click)="goto(page)">{{ page }}</div>
      <ng-template #asLink>
        <a [customRouterLink]="getGoToLink(page)" [params]="getQueryParams(page)" class="button page {{currentPage === page ? 'active' : ''}}">
          {{ page }}
        </a>
      </ng-template>
    </ng-container>
    <ng-container *ngIf="showLastPageEllipsis"><div class="ellipsis">...</div></ng-container>
    <ng-container *ngIf="showLastPage">
      <div *ngIf="!isLink else asLink" class="button page {{currentPage === totalPages ? 'active' : ''}}" (click)="goto(totalPages)">
        {{ totalPages }}
      </div>
      <ng-template #asLink>
        <a [customRouterLink]="getGoToLink(totalPages)" [params]="getQueryParams(totalPages)" class="button page {{currentPage === totalPages ? 'active' : ''}}">
          {{ totalPages }}
        </a>
      </ng-template>
    </ng-container>
    <div class="button arrow right {{ !canGotoNext ? 'disabled' : '' }}" (click)="gotoNext()">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M8.153 16.01L7.143 15 12.352 9.791 7.143 4.581 8.153 3.571 14.372 9.791z"/>
      </svg>
    </div>
  </div>
</div>
